import { render, staticRenderFns } from "./Abbreviation.vue?vue&type=template&id=99238018&scoped=true&"
import script from "./Abbreviation.vue?vue&type=script&lang=ts&"
export * from "./Abbreviation.vue?vue&type=script&lang=ts&"
import style0 from "./Abbreviation.vue?vue&type=style&index=0&id=99238018&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99238018",
  null
  
)

export default component.exports